import { gql } from "@apollo/client";

const READ = gql`
  query BulletinData(
    $entity: String!
    $id: Int
    $search: String
    $kind: String
    $page: Int
  ) {
    marketingBulletinData(
      entity: $entity
      id: $id
      search: $search
      kind: $kind
      page: $page
    )
  }
`;
const ACT = gql`
  mutation BulletinAction($action: String!, $data: GenericScalar!) {
    marketingBulletinAction(action: $action, data: $data) {
      result
    }
  }
`;
export const read = async (api, entity, options = {}) => {
  const { data } = await api.client.query({
    query: READ,
    variables: { entity, ...options },
    fetchPolicy: "network-only",
  });
  return data.marketingBulletinData;
};
export const act = async (api, action, input) => {
  const { data } = await api.client.mutate({
    mutation: ACT,
    variables: { action, data: input },
  });
  return data.marketingBulletinAction.result;
};
export const localId = (value) =>
  /^\d+$/.test(String(value))
    ? Number(value)
    : Number(atob(value).split(":").pop());
